import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

import { LogOutActions } from '../../../auth/logout/logout.actions';
import { GainsightPXService } from '../gainsight-px.service';

@Injectable()
export class GainsightPXEffects {
  private actions$ = inject(Actions);
  private gainsightPXService = inject(GainsightPXService);

  $resetSessionOnLogout = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LogOutActions.initiateLogOut),
        tap(() => this.gainsightPXService.resetSession())
      ),
    { dispatch: false }
  );
}
